
enum CollectTypeEnum {
  Login = 0,
  Register = 1,
  Identify = 2,
}

export default CollectTypeEnum;
